document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGaleriaProducto();
  initVariantes();
  initAgregarCarrito();
  initPopupNewsletter();
  initHeroCarrusel();
});

/* Carrusel de fotos del hero: cruza de opacidad automatica cada pocos segundos */
function initHeroCarrusel() {
  var contenedores = document.querySelectorAll('[data-vt-hero-carrusel]');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  contenedores.forEach(function (contenedor) {
    var slides = contenedor.querySelectorAll('.vt-hero__slide');
    if (slides.length < 2) return;

    var actual = 0;
    setInterval(function () {
      slides[actual].classList.remove('is-active');
      actual = (actual + 1) % slides.length;
      slides[actual].classList.add('is-active');
    }, 5000);
  });
}

/* Pop-up de newsletter: aparece tras un retraso, respeta una pausa tras cerrarse */
function initPopupNewsletter() {
  var popup = document.querySelector('[data-vt-popup-newsletter]');
  if (!popup) return;

  var CLAVE = 'vt_popup_newsletter_oculto_hasta';
  var retraso = parseInt(popup.getAttribute('data-retraso'), 10) || 0;
  var dias = parseInt(popup.getAttribute('data-dias'), 10) || 14;
  var exito = popup.getAttribute('data-exito') === 'true';

  function mostrar() {
    popup.hidden = false;
    requestAnimationFrame(function () {
      popup.classList.add('vt-visible');
      var input = popup.querySelector('.vt-popup__input');
      if (input) input.focus();
    });
  }

  function ocultar() {
    popup.classList.remove('vt-visible');
    setTimeout(function () { popup.hidden = true; }, 350);
    try {
      var ocultarHasta = Date.now() + dias * 24 * 60 * 60 * 1000;
      localStorage.setItem(CLAVE, String(ocultarHasta));
    } catch (e) { /* almacenamiento no disponible, no pasa nada */ }
  }

  popup.querySelectorAll('[data-vt-popup-cerrar]').forEach(function (el) {
    el.addEventListener('click', ocultar);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popup.hidden) ocultar();
  });

  if (exito) {
    mostrar();
    try { localStorage.setItem(CLAVE, String(Date.now() + dias * 24 * 60 * 60 * 1000)); } catch (e) {}
    return;
  }

  var ocultoHasta = 0;
  try { ocultoHasta = parseInt(localStorage.getItem(CLAVE), 10) || 0; } catch (e) {}
  if (Date.now() < ocultoHasta) return;

  setTimeout(mostrar, retraso * 1000);
}

/* Añade al carrito por AJAX y abre el cajón/notificación del carrito de Dawn */
function initAgregarCarrito() {
  var form = document.getElementById('vt-producto-form');
  if (!form) return;

  form.addEventListener('submit', function (evt) {
    evt.preventDefault();
    var boton = form.querySelector('[data-vt-boton-comprar]');
    if (!boton || boton.disabled) return;

    var textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = boton.getAttribute('data-texto-enviando') || 'Añadiendo...';

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var formData = new FormData(form);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        boton.disabled = false;
        boton.textContent = textoOriginal;

        if (response.status) {
          alert(response.description || response.message || 'No se pudo añadir al carrito.');
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        form.submit();
      });
  });
}

/* Revela elementos al hacer scroll (stagger via --vt-delay) */
function initReveal() {
  var els = document.querySelectorAll('.vt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el, i) {
    if (!el.style.getPropertyValue('--vt-delay')) {
      el.style.setProperty('--vt-delay', el.dataset.vtDelay || (i % 6));
    }
    observer.observe(el);
  });
}

/* Acordeon de preguntas frecuentes */
function initFaq() {
  var items = document.querySelectorAll('.vt-faq__item');
  if (!items.length) return;

  items.forEach(function (item) {
    var boton = item.querySelector('.vt-faq__pregunta');
    var respuesta = item.querySelector('.vt-faq__respuesta');
    if (!boton || !respuesta) return;

    boton.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';
      item.setAttribute('data-abierto', abierto ? 'false' : 'true');
      boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      respuesta.style.maxHeight = abierto ? null : respuesta.scrollHeight + 'px';
    });
  });
}

/* Galeria de la pagina de producto: clic en miniatura cambia la foto principal */
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-vt-galeria-producto]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-vt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-vt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        if (!src) return;
        principal.src = src;
        principal.alt = alt;
        miniaturas.forEach(function (m) { m.setAttribute('aria-current', 'false'); });
        mini.setAttribute('aria-current', 'true');
      });
    });
  });
}

/* Selector de variantes: actualiza precio, id del formulario y disponibilidad */
function initVariantes() {
  var forms = document.querySelectorAll('#vt-producto-form');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-vt-variantes-json]');
    if (!dataEl) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var pildoras = form.querySelectorAll('[data-vt-opcion-valor]');
    var inputId = form.querySelector('[data-vt-input-id]');
    var precioActual = form.querySelector('[data-vt-precio-actual]');
    var precioAnterior = form.querySelector('[data-vt-precio-anterior]');
    var botonComprar = form.querySelector('[data-vt-boton-comprar]');
    var disponibilidad = form.querySelector('[data-vt-disponibilidad]');
    var numOpciones = form.querySelectorAll('[data-vt-opcion]').length;

    function opcionesSeleccionadas() {
      var seleccion = [];
      for (var i = 1; i <= numOpciones; i++) {
        var activa = form.querySelector('[data-vt-opcion-index="' + i + '"][aria-current="true"]');
        seleccion.push(activa ? activa.getAttribute('data-vt-opcion-valor') : null);
      }
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;

      if (inputId) inputId.value = variante.id;
      if (precioActual) precioActual.textContent = formatearDinero(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatearDinero(variante.compare_at_price);
          precioAnterior.hidden = false;
        } else {
          precioAnterior.hidden = true;
        }
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (disponibilidad) {
        if (!variante.available) {
          disponibilidad.textContent = disponibilidad.getAttribute('data-texto-agotado') || 'Agotado';
          disponibilidad.setAttribute('data-estado', 'agotado');
        } else {
          disponibilidad.textContent = disponibilidad.getAttribute('data-texto-disponible') || 'En stock, listo para enviar';
          disponibilidad.setAttribute('data-estado', 'disponible');
        }
      }

      pildoras.forEach(function (p) {
        var seleccion = opcionesSeleccionadas();
        var index = parseInt(p.getAttribute('data-vt-opcion-index'), 10);
        var otros = seleccion.slice();
        otros[index - 1] = p.getAttribute('data-vt-opcion-valor');
        var existe = variantes.some(function (v) {
          return v.options.every(function (val, i) { return val === otros[i]; });
        });
        p.disabled = !existe;
      });
    }

    pildoras.forEach(function (p) {
      p.addEventListener('click', function () {
        var index = p.getAttribute('data-vt-opcion-index');
        form.querySelectorAll('[data-vt-opcion-index="' + index + '"]').forEach(function (h) {
          h.setAttribute('aria-current', 'false');
        });
        p.setAttribute('aria-current', 'true');
        actualizar();
      });
    });

    actualizar();
  });
}
